import { getRoute } from '~/src/dash/router/routes';

export const routeName = (pathname: string) => {
  try {
    return getRoute(pathname).title;
  } catch (e) {
    return 'Not Found';
  }
};
